export const isLicenseFeatureAssigned = (licenses, featureName) => {
  let isFeatureAssigned = false;

  licenses?.some((license) => {
    license?.licenseDefinition?.assignedServices?.some((assignedService) => {
      assignedService?.assignedFeatures?.some((assignedFeature) => {
        const assignedFeatureName = assignedFeature?.name;
        if (assignedFeatureName === featureName) isFeatureAssigned = true;

        return isFeatureAssigned;
      });
      return isFeatureAssigned;
    });
    return isFeatureAssigned;
  });

  return isFeatureAssigned;
};
